import { normalizeUsername, validateUsername } from "./usernameValidation";

export function normalizeLoginValues(values) {
  return {
    username: normalizeUsername(values.username),
    password: values.password,
  };
}

export function validateLoginValues(values) {
  const normalized = normalizeLoginValues(values);
  const errors = {};

  const usernameError = validateUsername(normalized.username);
  if (usernameError) {
    errors.username = usernameError;
  }

  if (!normalized.password) {
    errors.password = "La contraseña es obligatoria.";
  }

  return errors;
}
